import { USER_ROLES } from 'src/common/constants';

export const isRole = (roles, user) => {
  if (!user) return false;

  if (Array.isArray(roles)) {
    return roles.includes(user.roles[0].role.name);
  }

  return roles === user.roles[0].role.name;
};

export const isExternalPartyRole = (user) =>
  isRole(
    [USER_ROLES.HOME_OWNER, USER_ROLES.REALTOR, USER_ROLES.OCCUPANT],
    user
  );
